import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type SystemSettingsMap = Record<string, any>;

const DEFAULTS: SystemSettingsMap = {
  maintenance_mode: { enabled: false, message: '' },
  default_city: { value: 'Addis Ababa' },
  default_currency: { value: 'ETB' },
  etb_to_usd_rate: { value: 0.0078 },
  feature_flags: {
    email_channel: false,
    payments_live: false,
    boost_console: true,
    reviews_moderation: true,
  },
  site_contact: { email: '', phone: '' },
};

/**
 * Reads the public system_settings rows. RLS exposes only those marked is_public=true,
 * which covers all settings we read on the public site.
 */
export function useSystemSettings() {
  const query = useQuery({
    queryKey: ['system-settings'],
    queryFn: async () => {
      const { data } = await supabase
        .from('system_settings' as any)
        .select('key, value');
      const map: SystemSettingsMap = { ...DEFAULTS };
      (data || []).forEach((row: any) => {
        map[row.key] = row.value;
      });
      return map;
    },
    staleTime: 60_000,
  });

  return {
    settings: query.data ?? DEFAULTS,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}

export function useFeatureFlag(flag: string): boolean {
  const { settings } = useSystemSettings();
  return Boolean(settings.feature_flags?.[flag]);
}
